import { render } from "./Review.vue?vue&type=template&id=5325a0e2"
import script from "./Review.vue?vue&type=script&lang=ts"
export * from "./Review.vue?vue&type=script&lang=ts"
script.render = render

export default script